import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const shadowBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'shadow-bar-sufficient-categories',
      validator: (data, layer) => {
        const { encoding } = layer;
        const zValues = new Set(data.map(item => item[encoding?.z as string]));
        return zValues.size >= 2;
      },
      message: 'Shadow bar chart requires at least 2 different z-field values for comparison',
      suggestion: 'Provide data with at least 2 categories in the z field for shadow effect',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'shadow-bar-paired-data',
      validator: (data, layer) => {
        const { encoding } = layer;
        const xValueCounts = new Map<string | number, Set<string | number>>();

        data.forEach(item => {
          const xValue = item[encoding?.x as string];
          const zValue = item[encoding?.z as string];

          if (!xValueCounts.has(xValue)) {
            xValueCounts.set(xValue, new Set());
          }
          xValueCounts.get(xValue)?.add(zValue);
        });

        // 检查每个X值是否有至少2个Z值对应
        return Array.from(xValueCounts.values()).every(zSet => zSet.size >= 2);
      },
      message:
        'Shadow bar chart requires paired data - each x value should have multiple z categories',
      suggestion:
        'Ensure each x-axis value has records for different z-field categories for comparison',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'shadow-bar-sufficient-data',
      validator: data => data.length >= 4,
      message: 'Shadow bar chart requires at least 4 data points for meaningful comparison',
      suggestion: 'Provide at least 4 data points (2 x-values × 2 z-categories minimum)',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
